import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ancillaryTitles } from '@app/pages/ancillary-bundle-page/ancillary-bundle.constants';
import { AncillaryBundleItemType } from '@app/pages/ancillary-bundle-page/ancillary-bundle.enum';

@Component({
  selector: 'upsell-info-badge',
  templateUrl: './upsell-info-badge.component.html',
  styleUrl: './upsell-info-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellInfoBadgeComponent {
  ancillaryTitles = ancillaryTitles;

  @Input() pricePerTraveler?: number;
  @Input() type?: AncillaryBundleItemType;
}
